<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";
import PageActionBar from "@/components/page-action-bar.vue";

export default {
  page: {
    title: "Editar OS Saída",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Loader, Layout, PageHeader, Multiselect, PageActionBar },
  data() {
    return {
      title: "Editar OS de Saída",
      items: [
        {
          text: "Ordens de Serviço",
          href: "/wmsossaida/list",
        },
        {
          text: "Editar OS de Saída",
          active: true
        }
      ],
      itenswmsos: {},
      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsListData: null,
      wmsOsData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },
      wmsOsDuplicadaData: null,
      // desativaFuncoes: false,
      clienteData: {},
      movData: {},
      wmsOsItemData: {},
      wmsOsItensData: {},
      wmsOsItensSepData: {},
      wmsOsItensSepPendData: [],
      wmsOsVolumesData: {},
      wmsOsVolumeData: {
        caixa: 1
      },
      optionsCaixas: {},

      submitted: false,
      errosValid: null,
      tipoConferencia: 'A',
      tipoVolume: 'A',
      showModalVolume: false,
      loadingWmsVolume: false,
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      showAssocRoma: false,
      showModalLote:false,
      dtListPesqRoma: null,
      disabledChave: false,
      flagAvulso: false,
      flagdispconf: null,
      autoImpressao: true,
      empresaData: {},
      mudarConferencia: 'P',

      flagConferenciaCompos: false,
      wmsositemLotes: [],
      dtListLotes: [],
      itemResetLote: {
        endwms: "-",
        lote: "-",
      },
      flagProdutoSaldoWmsos: false,

      showModalErrosProdutos: false,
      dtListErrorsProdutos: [],
      remetCnpj: null,

      showModalAssociaLotes: false,
      updatingReserva: false,
      dtListAssociaLote: [],
      selectedFinalizado: false,
      showModalMsgUpdating: false,
      qtdItens: 0,
      dadosConferentes: {},
      flagParametroPdf: false,
      finalizarParcialBtn: false,
      totalItens: 0,
      flagFinalizado: false
    }
  },
  created() {
  },
  mounted() {
    console.log('mounted_wmsOs_editar_transp_0')
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.produto.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })

    whenever(keys.alt_a, () => {
      this.efetivarSepPend2()
    })

    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0) {
      this.carregarDados()

    } else {
      console.log('new wmsos...')

      this.title = `Criando Nova OS`
      this.updating = false
      this.flagAvulso = true
      this.autoImpressao = false //Quando wmsos for conferência única, autoImpressão é desabilitada por padrão

      setTimeout(() => {
        this.$refs.chave.focus()
      }, 500)
    }
  },

  computed: {
    computedDisabledChave(){
      if(this.idData === 0){
        return false
      }else{
        return true
      }
    }
  },

  methods: {
    gerarReservaSaldos(){
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote,
          iddata: this.idData
        }).then((res) => {
          console.log("then axios reservasaldolotes");
          console.log(res.data)
          console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    criaMovAjtFromWms() {
      console.log('criaMovAjtFromWms')

      api.post(`${getBaseUrl()}api/criamovajtmovs`, {
        produtosErros: this.dtListErrorsProdutos,
        remetcnpj: this.remetCnpj,
        tabela: 'mov',
        origens_id: this.listaIds
      }).then((res) => {
        console.log('then axios criamovajtmovs')
        console.log(JSON.stringify(res.data))

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message ?? "Ajuste criado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            const movajt_id = res.data.movajt_id
            if(movajt_id > 0) {
              let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
              window.open(route.href, '_blank');
              this.showModalErrosProdutos = false
            } else {
              let route = this.$router.resolve(`/movajustes/list`);
              window.open(route.href, '_blank');
            }

          });
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error ?? "Criação de Ajuste Falhou!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.carregarDados()
          });
        }
      })
    },

    selecionouLote(evt) {
      console.log('selecionouLote')
      // console.log(evt)

      if (evt !== null ) {
        let selecionados = Array.isArray(evt) ? evt : [evt]

        let lotesSelecionados = this.dtListLotes.filter(lote => selecionados.includes(lote.lote))

        console.log('lotesSelecionados')
        console.log(lotesSelecionados)

        const item = this.wmsOsItensData.find(i => i.produto_id === this.wmsOsItemData.produto_id)

        if (!item) {
          console.error('item não encontrado!')
        }

        item.endwms = lotesSelecionados.map(lote => lote.endwms)
        item.lote = lotesSelecionados.map(lote => lote.lote)
      }

      this.informouProduto()
      this.$refs.qtdlida.focus()
    },

    opcoesLotes(){
      // console.log('---------opcoesLotes---------')
      // console.log('wmsOsItemData: ' , idProd)

      api.get(`${getBaseUrl()}api/pesqlotes`, {
        params: {
          produto_id: this.wmsOsItemData["produto_id"],
          qtd: this.wmsOsItemData["qtddisp"],
        },
      }).then((res) => {
        console.log("then axios pesqlotes");
        console.log(res.data);

        this.dtListLotes = res.data

        this.showModalLote = true
      })
    },

    redirecionaOrigem(){
      console.log('redirecionaOrigem')
      let url = ''
      switch(this.wmsOsData.origem) {
        case 'orcamento':
            url = `/orcamento/editar/${this.wmsOsData.origem_id}`
            window.open(url, '_blank')
              break
        case 'mov':
          url = `/movimento/editar/${this.wmsOsData.origem_id}`
          window.open(url, '_blank')
              break
        case 'movcompra':
          url = `/movcompra/editar/${this.wmsOsData.origem_id}`
          window.open(url, '_blank')
              break
      }
    },

    finalizarParcial(){
      console.log('finalizarParcial')
      if (this.empresaData?.editvolfinconf === true) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Deseja editar os Volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'conffinparcial'
          } else {
            this.confFinalizarParcial()
          }
        })
      } else {
        this.confFinalizarParcial()
      }
    },

    confFinalizarParcial(){
      console.log('conffinalizarParcial...')

      Swal.fire({
        position: "center",
        icon: 'info',
        title: 'Confirmar a finalização parcial',
        showCancelButton: true,
        showConfirmButton: true
      }).then((value) => {
        console.log(value)
        if(value.isConfirmed){
          this.selectedFinalizado = true
          this.showModalMsgUpdating = true

          api.post(`${getBaseUrl()}api/wmsosfinalparcial`, {
            'movItemSepPendData': this.wmsOsItensSepPendData,
            'movItemSepData': this.wmsOsItensSepData,
            'idwmsos': this.idData
          }).then((res) => {
            this.selectedFinalizado = false
            this.showModalMsgUpdating = false
            console.log('then axios finalizarParcial')
            console.log(res.data)

            setTimeout(() => {
              this.imprimirPdf()
            },200)

            let flag = res.data.success ?? false

            if(flag){
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                title: 'Redirecionando para o pedido gerado!',
                timer: 1500
              }).then(() => {
                //this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
                this.$router.push(`/wmsossaida/list`)
              })
            }else{
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              })
            }
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
        }
      })
    },

    efetivarSepPend(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      api.post(`${getBaseUrl()}api/wmsositconfseptramuito`, {
        'movItemSepPendData': this.wmsOsItensSepPendData,
        'autoImpressao': this.autoImpressao,
        'idwmsos': this.idData
      }).then((res) => {
        console.log('then axios separarPend')
        console.log(res.data)

        this.wmsOsItensSepData = res.data[0]
        this.wmsOsData = res.data[1]

        /*
        * Validando se conferência foi finalizada
        * Se origem for mov, retornar para lista
        */
        if(this.wmsOsData.origem === 'mov'){
          this.$router.replace(`/wmsossaida/list`)
        }

        this.wmsOsItensData = this.filtrarDisponiveis(res.data[2])
        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }
        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }
        this.wmsOsVolumesData = res.data[3]
        if (this.wmsOsItensData.length === 0) {
          console.log('finalizar_auto')
          this.wmsOsData.status = 'SE'
          this.confirmarFinalizar()
          //this.imprimirPdf()
        } else {
          console.log('produto focus')
          setTimeout(() => {
            this.$refs.produto.focus()
          }, 500);
        }
      }).then(() => {
        this.updatingListas = false
        this.wmsOsItemData.qtd = 0
        this.wmsOsItemData.qtdlida = 0
        this.wmsOsItemData.produto = ''
      })
    },


    efetivarSepPend2(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      api.post(`${getBaseUrl()}api/wmsositconfseptramuito`, {
        'movItemSepPendData': this.wmsOsItensSepPendData,
        'autoImpressao': this.autoImpressao,
        'idwmsos': this.idData
      }).then((res) => {
        console.log('then axios separarPend2')
        console.log(res.data)
        console.log(JSON.stringify(res.data))
        

        if(!res.data.finalizado){
          console.log('conferência salva')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {

            this.atualizaPagina()
          })
        }
      })
    },

    changeAutoImpressao(){
      this.autoImpressao = !this.autoImpressao
      console.log(`auto impressão: ${this.autoImpressao}`)
    },

    recarregaWmsosAvulso(){
      console.log('recarregando conferência avulsa...')

      this.$router.push(`/wmsos/saidaeditar/0`).then((blankWmsos) => {
        window.open(blankWmsos, '_self')
        this.atualizaPagina()
      })
    },

    carregaWmsOs(){
      console.log(`nota fiscal: ${this.movData.chave}`)

      if(!this.movData.chave){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Ordem de Serviço inválida!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        api.post(`${getBaseUrl()}api/wmsosindividual`, {
          'chave': this.movData.chave
        }).then((res) => {
          console.log('then axios wmsosindividual')
          console.log(res.data)

          if(!res.data.success){
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          }else{
            this.movData = res.data.wmsos
            this.idData = this.movData.id

            this.$router.push(`/wmsos/saidaeditarnova/${this.movData.id}`)
            this.carregarDados()
          }
        }).catch(() => {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Chave de nota inválida",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    excluir() {
      console.log('excluir')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Ordem",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/wmsos`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

              if(res.data.redirecionaEstoque){
              Swal.fire({
                position: "center",
                icon: "warning",
                title: "Saldo bloqueado!",
                text: "Deseja redirecionar-se transferência de saldos?",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
              }).then((check) => {
                if(check.isConfirmed){
                  this.$router.push('/produtos/listestoque')
                }else{
                  this.$router.push('/wmsossaida/list')
                }
              })
            }else{
              if(res.data.success){
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.$router.replace('/wmsossaida/list')
                })
              }else{
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          })
        }
      })
    },

    onModalClosed() {
      console.log('onModalClosed')
      this.showModalVolume = false

      if(this.flagdispconf !== null) {
        if(this.flagdispconf === 'finConfSepTodos'){
          // console.log('confSepararTodos')
          this.confSepararTodos()
        }else if(this.flagdispconf === 'finConfIndividual') {
          // console.log('disparoFinalizadorConferencia')
          this.disparoFinalizadorConferencia()
        } else if(this.flagdispconf === 'conffinparcial'){
          // console.log('confFinalizarParcial')
          this.confFinalizarParcial()
        }
      }
    },

    separarTodos() {
      console.log('separarTodos')

      if (this.empresaData?.editvolfinconf === true) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Volumes Separar Todos",
          text: "Deseja adicionar ou editar os volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'finConfSepTodos'
          } else {
            this.confSepararTodos()
          }
        })

      } else {
        this.confSepararTodos()
      }

    },

    confSepararTodos() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Separar Todos Itens",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          console.log(result.value)
          console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true
          this.selectedFinalizado = true
          this.showModalMsgUpdating = true
          api.post(`${getBaseUrl()}api/wmsosseptodos`, {
            'iddata': this.idData
          }).then((res) => {
            this.selectedFinalizado = false
            this.showModalMsgUpdating = false
            console.log('then axios separar2_1')
            console.log(res.data)
            setTimeout(() => {
              this.imprimirPdf()
            }, 200);

            let flag = res.data.success ?? false

            if(flag){
              const proxWmsos = res.data?.wmsosprox_id ?? null
              console.log('prox. wmsos: ' , proxWmsos)

              if (this.empresaData?.redfinconf === true && proxWmsos !== null) { //res.data?.fluxo === 'orcamento'
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: 'Redirecionando para próxima OS em aberto!',
                  timer: 1500
                }).then(() => {
                  //this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
                  // this.$router.push(`/wmsossaida/list`)
                  //Verificando qual próximo processo direcionar o cliente

                  // this.$router.push(`/wmsos/saidaeditarnova/${proxWmsos}`)
                  this.idData = proxWmsos
                  this.$router.replace({ path: `/wmsos/saidaeditarnova/${this.idData}` });
                  this.carregarDados()
                })
              } else {
                Swal.fire({
                  icon: 'success',
                  position: 'center',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: res.data.message,
                  timer: 2500
                }).then(() => {
                  this.$router.push(`/wmsossaida/list`)
                })
              }
            }else{
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              })
            }
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
        }
      })

    },

    finalizadorConferencia() {
      console.log('finalizadorConferencia')
      if (this.empresaData?.editvolfinconf === true) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Deseja editar os Volumes?",
          confirmButtonText: "Sim",
          cancelButtonText: "Pular",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.showModalVolume = true
            this.flagdispconf = 'finConfIndividual'
          } else {
            this.disparoFinalizadorConferencia()
          }
        })

      } else {
        this.disparoFinalizadorConferencia()
      }
    },

    disparoFinalizadorConferencia() {
      console.log('disparoFinalizadorConferencia')

      this.wmsOsItemData['idwmsos'] = this.idData
      this.updatingListas = true
      this.selectedFinalizado = true
      this.showModalMsgUpdating = true
      api.post(`${getBaseUrl()}api/wmsosseptodos`, {
        'iddata': this.idData
      }).then((res) => {
        this.selectedFinalizado = false
        this.showModalMsgUpdating = false
        console.log('then axios separar2_1')
        console.log(res.data)

        setTimeout(() => {
          this.imprimirPdf()
        }, 200);

        let flag = res.data.success ?? false

        if(flag){
          const proxWmsos = res.data?.wmsosprox_id ?? null
          console.log('prox. wmsos: ' , proxWmsos)

          if ((this.empresaData?.redfinconf === true && proxWmsos !== null)) {
            Swal.fire({
              icon: 'success',
              position: 'top-end',
              showCancelButton: false,
              showConfirmButton: false,
              title: 'Redirecionando para próxima OS em aberto!',
              timer: 1500
            }).then(() => {
              //this.$router.push(`/pedido/detalhe/${res.data.pedido_id}`)
              // this.$router.push(`/wmsossaida/list`)
              //Verificando qual próximo processo direcionar o cliente

              // this.$router.push(`/wmsos/saidaeditarnova/${proxWmsos}`)
              this.idData = proxWmsos
              this.$router.replace({ path: `/wmsos/saidaeditarnova/${this.idData}` });
              this.carregarDados()
            })
          } else {
            Swal.fire({
              icon: 'success',
              position: 'center',
              showCancelButton: false,
              showConfirmButton: false,
              title: res.data.message,
              timer: 2500
            }).then(() => {
              if(res.data.success && res.data.fluxo === "orcamento" && res.data.pedido_id){
                Swal.fire({
                  icon: 'question',
                  position: 'center',
                  showCancelButton: true,
                  cancelButtonText: "Não",
                  showConfirmButton: true,
                  confirmButtonText: "Sim", 
                  title: "Deseja acessar o pedido?",
                }).then((resRedir) => {
                  if(resRedir.isConfirmed){
                    this.$router.replace({ path: `/pedido/detalhe/${res.data.pedido_id}`});
                  } else {
                    this.$router.push(`/wmsossaida/list`)
                  }
                })
              }
            })
          }
        }else{
          Swal.fire({
            icon: 'error',
            position: 'top-end',
            showCancelButton: false,
            showConfirmButton: false,
            text: res.data.message,
            timer: 3000
          })
        }
      }).catch((e) => {
        console.log('error...')
        console.log(e)
      })
    },


    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CF':
          result = 'Conferido'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'EQ':
          result = 'Embarque'
          break
        case 'FN':
          result = 'Finalizado'
          break
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    excluirEtiquetas() {
      console.log('excluirEtiquetas')
      this.showModalVolume = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Todas as Etiquetas",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/wmsosetiquetas`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    associarRomaneio() {
      console.log('associarRomaneio')
      if (this.wmsOsData.origem2 === 'romaneio') {
        this.$router.push(`/wmsos/saidaromaeditar/${this.idData}`)
      } else {
        this.showAssocRoma = true
      }
    },

    atualizaPagina() {
      window.location.reload();
    },

    confirmarAssocRoma() {
      console.log('associarRomaneio')
      // console.log(this.wmsosList)

      let idsAssoc = []
      idsAssoc.push(this.idData)


      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        idRoma: this.wmsOsData.wmsroma_id,
        idsData: idsAssoc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        //this.atualizaDataList()
      })
    },


    pesqRomaneio(evt) {
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },


    imprimirEtiquetas() {
      console.log('imprimirEtiqueta')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstra`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        // var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        // var fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', 'etiqueta_.pdf');
        // document.body.appendChild(fileLink);
        // fileLink.click();


        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Impressão enviada com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      })
    },


    imprimirEtiquetasZpl() {
      console.log('imprimirEtiqueta')
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsosvoletiqstrazpl`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then imprimirEtiquetas')
        console.log(res.data)
        // var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        // var fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', 'etiqueta_.zpl');
        // document.body.appendChild(fileLink);
        // fileLink.click();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Comando de impressão executado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.updating = false
      })
    },


    imprimirEtiquetasMiniDanfe() {
      console.log('imprimirEtiquetasMiniDanfe')
      this.updating = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqstrazpl`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {

        console.log('then imprimirEtiquetas')
        console.log(res.data)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.zpl');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },

    escolheuCaixa(){
      console.log('escolheuCaixa')
      // const caixaId = this.wmsOsVolumeData.caixa;
      // console.log('caixaId', caixaId)
      // const caixaSelecionada = this.optionsCaixas.find(c => c.id === caixaId);
      this.$refs.qtdvolume.focus()
    },


    informouQtdVolume() {
      console.log('informouQtdVolume')
      this.$refs.pesovolume.focus()

    },

    informouPeso() {
      console.log('informouPeso')
      this.confirmarVolume()

    },

    imprimirEtiqueta(idVol) {
      console.log('imprimirEtiqueta')
      this.loadingWmsVolume = true

      api.get(`${getBaseUrl()}api/wmsosvoletiqtra`, {
        responseType: 'blob',
        params: { iddata: idVol }
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'etiqueta_.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingWmsVolume = false
      })

    },


    finalizar() {
      console.log('finalizar')


      // if (this.wmsOsData.qtddisp === 0.00) {

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Finalizar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.confirmarFinalizar()
        }
      })
    },

    confirmarFinalizar(){
      console.log('confirmarFinalizar')
      // console.log('vai')
      // this.wmsOsItemData['idwmsos'] = this.idData
      // this.updatingListas = true
      //
      api.post(`${getBaseUrl()}api/wmsosfinalsep`, {
        'iddata': this.idData,
        // 'autoImpressao': this.autoImpressao,
        // 'Validar': 1

      }).then((res) => {
        console.log('then axios separar2_0')
        console.log(res.data)

        if (res.data.processo === 'pedido') {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comando Finalizar executado com sucesso, abrindo pedido de destino.",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$router.push(`/pedido/detalhe/${res.data['id']}`)
          })
          // console.log('redirect to pedido')
          // this.$router.push(`/pedido/detalhe/${res.data['id']}`)
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Comando Finalizar executado com sucesso, abrindo próxima OS em aberto.",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            //Verificando qual próximo processo direcionar o cliente
            // this.$router.push(`/wmsos/saidaeditarnova/${res.data['id']}`)
            // this.idData = res.data['id']
            // this.carregarDados()
            if(this.flagAvulso){
              this.recarregaWmsosAvulso()
            }else{
              const routeData = this.$router.resolve(`/wmsos/saidaeditarnova/${res.data['id']}`)
              window.open(routeData.href, '_blank')
            }
          })
        }
      })
    },


    abrirOutraOS(idos) {
      const routeData = this.$router.resolve(`${idos}`)
      window.open(routeData.href, '_blank')
    },

    reiniciar() {
      console.log('reiniciar')

      if(this.wmsOsItemData.length === 0){
        Swal.fire({
          position: "center",
          icon: "info",
          title: "OS já foi finalizada, reinício é proibido!",
          timer: 2500
        })

        return
      }

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          console.log(result.value)
          console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosreinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2_1')
            console.log(res.data)
            this.wmsOsItensSepData = {}
            this.wmsOsItemData.produto = ''

            this.wmsOsItensData = this.filtrarDisponiveis(res.data[0])

            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }



            this.wmsOsData = res.data[1]
            this.updatingListas = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })

    },


    clicouProduto(codigo, iditem, produto_id, compos_qtd, compos_fator, lote, endwms) {
      //console.log('=============== clicouProduto ===============')

      if(this.wmsOsItensSepData.length === 0){

        api.get(`${getBaseUrl()}api/wmsoslog`, {
          params: {
            iddata: this.idData,
            message: "Iniciada conferência"
          }
        }).then((response) =>{
          console.log(response.data)
        })
      }

      this.wmsOsItemData.produto = codigo
      this.wmsOsItemData.produto_id = produto_id
      this.wmsOsItemData.iditem = iditem
      this.wmsOsItemData.endwms = endwms ?? null
      this.wmsOsItemData.lote = lote ?? null

      /*
      * Valida se conferência contém item composto
      */
      let qtddisp = 0
      let qtd = 0
      this.wmsOsItensData.forEach((item) => {

        if (item.id === this.wmsOsItemData.iditem) {
          //console.log(`item encontrado clicou produto: ${JSON.stringify(item)}`)

          if(item.desconsidsaldo){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Item com saldo desconsiderado para conferência!",
              text: "Item indisponível",
              showConfirmButton: false,
              timer: 2000
            })

            this.wmsOsItemData = {}
          }

          if(this.flagConferenciaCompos) {
            this.wmsOsItemData.compos_qtd = parseFloat(compos_qtd)
            this.wmsOsItemData.compos_fator = compos_fator
          }

          qtddisp = item.qtddisp
          qtd = item.qtddisp
          this.wmsOsItemData.descprod = item.descprod
        }

        this.wmsOsItemData.qtdlida = 0
        this.wmsOsItemData.qtd = qtd ?? item.qtddisp
        this.wmsOsItemData.qtddisp = qtddisp ?? item.qtddisp
      });

      //console.log(`wmsOsItemData clicouProduto: ${JSON.stringify(this.wmsOsItemData)}`)
      this.$refs.produto.focus()
    },


    informouProduto() {
      //console.log('=============== informouProduto ===============')

      if(this.wmsOsData.status === 'SE' && this.wmsOsData.status === 'SE'){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Operação proibida",
          text: "Status de separação e da ordem de saída estão fechados para edição!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        let encontrouProd = false

        if(this.wmsOsItemData === null || (!this.wmsOsItemData.iditem && this.wmsOsItemData.produto)) {
          let qtddisp = 0
          let qtd = 0
          this.wmsOsItensData.forEach((value) => {
            if ((value.id === this.wmsOsItemData.iditem) || (this.wmsOsItemData.produto === value.produto) || (this.wmsOsItemData.produto === value.codbarra)) {
              console.log('primeiro caso')
              this.wmsOsItemData.produto = value.produto
              this.wmsOsItemData.produto_id = value.produto_id
              this.wmsOsItemData.descprod = value.descprod
              this.wmsOsItemData.qtd = value.qtddisp
              this.wmsOsItemData.iditem = value.id
              this.wmsOsItemData.lote = value.lote ?? null

              if (value.id === this.wmsOsItemData.iditem) {

                if(value.desconsidsaldo){
                  Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Item com saldo desconsiderado para conferência!",
                    text: "Item indisponível",
                    showConfirmButton: false,
                    timer: 2000
                  })

                  this.wmsOsItemData = {}
                }

                if(this.flagConferenciaCompos) {
                  const composicao = value.composicao
                  this.wmsOsItemData.compos_qtd = parseFloat(composicao.qtd)
                  this.wmsOsItemData.compos_fator = composicao.fator
                }

                qtddisp = value.qtddisp
                qtd = value.qtddisp
                this.wmsOsItemData.descprod = value.descprod
              }

              this.wmsOsItemData.qtdlida = 0
              this.wmsOsItemData.qtd = qtd ?? value.qtddisp
              this.wmsOsItemData.qtddisp = qtddisp ?? value.qtddisp

              if (this.tipoConferencia === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  this.wmsOsItemData.qtdlida = 1

                }

                //console.log(`wmsOsItemData informouProduto: ${JSON.stringify(this.wmsOsItemData)}`)
                this.informouQtdLida2()
              } else {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
              }
              encontrouProd = true
            }
          });
        } else {
          //console.log('segundo caso')

          this.wmsOsItensData.forEach((value) => {
            if(value.id === this.wmsOsItemData.iditem) {
              if (this.tipoConferencia === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  //console.log('quantidade produto composto')
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  //console.log('quantidade automática')
                  this.wmsOsItemData.qtdlida = 1
                }

                //console.log(`wmsOsItemData informouProduto: ${JSON.stringify(this.wmsOsItemData)}`)
                this.informouQtdLida2()
              } else {
                this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
              }
              encontrouProd = true
            }
          });
        }
        if (!encontrouProd) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Produto Inválido",
            text: "Código inválido ou já finalizado!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    informouQtdLida() {
      console.log('=============== informouQtdLida ===============')
      console.log(`qtdlida: ${this.wmsOsItemData.qtdlida}`)
      console.log(`qtddisp: ${this.wmsOsItemData.qtddisp}`)
      console.log(`wmsOsItemData: ${JSON.stringify(this.wmsOsItemData)}`)


      let passaSaldo = false
      let qtdLidaAtual = 0

      //!this.wmsOsItemData.qtddisp || this.wmsOsItemData.qtdlida > this.wmsOsItemData.qtddisp
      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        if (
          window.location.href.includes('localhost')
          || window.location.href.includes('compose')
          || window.location.href.includes('grupofesta')
          || window.location.href.includes('granlog')
          || window.location.href.includes('vitascience')
          || window.location.href.includes('jsalog')
          || window.location.href.includes('econopro')
          || window.location.href.includes('delio') //Ambiente de testes do Délio
        ) {
          // acumular lista para separar muitos
          console.log('acumular lista para separar muitos')

          let quantDisponivel = false

          for(const prod of this.wmsOsItensData) {
            if (prod.id === this.wmsOsItemData.iditem) {
              console.log(`prod atual para baixa: ${JSON.stringify(prod)}`);

              if (prod.deflote && !prod.lote) {
                this.opcoesLotes()
                return;
              }

              this.showModalLote = false

              qtdLidaAtual = this.roundToDecimal(parseFloat(this.wmsOsItemData.qtdlida), 4);
              console.log(`baixa qtdLidaAtual: ${qtdLidaAtual}`);

              if (prod.composicao) {
                if (prod.qtddisp >= 0) {
                  console.log('baixa de produto composição...');

                  prod.qtdlida += qtdLidaAtual;
                  prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                  quantDisponivel = true;
                  console.log(`qtddisp remaining: ${prod.qtddisp}`);

                  // Validando se terminou de conferir o item atual
                  if (prod.qtddisp < 0) {
                    prod.qtddisp = 0;
                    quantDisponivel = false;
                  }
                }
              } else {
                console.log('baixa de produto comum...');

                if (prod.qtddisp >= qtdLidaAtual) {
                  prod.qtdlida += qtdLidaAtual;
                  prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                  quantDisponivel = true;
                }
              }

              if (prod.qtddisp === 0) {
                this.wmsOsItensData.splice(this.wmsOsItensData.indexOf(prod), 1);
              }
              break;
            }
          }


          if (quantDisponivel === false) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Quantidade do produto indisponível para separação",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          } else {
            if (this.wmsOsItemData.lote) {
              console.log("LOTE INFORMADO")

              const lote = this.wmsOsItemData.lote;
              console.log(`informouQtdLida lote: ${lote}`)

              const endwms = this.wmsOsItemData.endwms
              console.log(`informouQtdLida endwms: ${endwms}`)

              let existeProdPend = false;
              let existeProd = false;

              /* verificando se lote já existe em wmsOsItensSepPendData */
              this.wmsOsItensSepPendData.forEach((prod) => {
                //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProdPend = true;
                  console.log('atualizando dados do item na lista wmsOsItensSepPendData')

                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                    console.log('baixa qtd composição')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    console.log('baixa qtd comum')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /* verificando se lote já existe em in wmsOsItensSepData */
              this.wmsOsItensSepData.forEach((prod) => {
                console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProd = true;
                  console.log('atualizando dados do item na lista wmsOsItensSepData')

                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                    console.log('baixa qtd composição')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    console.log('baixa qtd comum')

                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /* Criando novos itens nas coleções */
              if (!existeProdPend) {
                console.log('criando novo item na lista wmsOsItensSepPendData')

                this.wmsOsItensSepPendData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'lote': lote,
                  'endwms': endwms,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }

              if (!existeProd) {
                console.log('criando novo item na lista wmsOsItensSepData')

                this.wmsOsItensSepData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                  'lote': lote,
                  'endwms': endwms,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }
              console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
              console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)

            } else {
              console.log("LOTE NÃO INFORMADO")

              let existeProdPend = false;
              let existeProd = false;

              this.wmsOsItensSepPendData.forEach((prod) => {
                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProdPend = true;
                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });


              this.wmsOsItensSepData.forEach((prod) => {
                if (prod.iditem === this.wmsOsItemData.iditem) {
                  existeProd = true;
                  if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  } else {
                    prod.qtd += qtdLidaAtual
                    prod.qtdlida += qtdLidaAtual
                    prod.qtdtotal -= qtdLidaAtual
                  }
                }
              });

              /*Criando novos itens nas coleções */
              if (!existeProdPend) {
                console.log('criando novo wmsOsItensSepPendData')

                this.wmsOsItensSepPendData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.wmsOsItemData.qtdlida,
                  'qtd': this.wmsOsItemData.qtdlida,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }

              if (!existeProd) {
                console.log('criando novo wmsOsItensSepData')

                this.wmsOsItensSepData.push({
                  'iditem': this.wmsOsItemData.iditem,
                  'descprod': this.wmsOsItemData.descprod,
                  'imgs': '',
                  'produto': this.wmsOsItemData.produto,
                  'produto_id': this.wmsOsItemData.produto_id,
                  'qtdlida': this.wmsOsItemData.qtdlida,
                  'qtd': this.wmsOsItemData.qtdlida,
                  'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
                });
              }
              console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
              console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)
            }

            //ordenando em desc e destacando o item atual para o topo
            const idItemAtual = this.wmsOsItemData.iditem

            const itemAtual = this.wmsOsItensSepData.find(item =>
                item.iditem === idItemAtual
            );
            const outrosItens = this.wmsOsItensSepData.filter(item =>
                !(item.iditem === idItemAtual)
            );

            if (outrosItens && outrosItens.length > 0) {
              outrosItens.sort((a, b) => b.iditem - a.iditem);

              this.wmsOsItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
            } else if (itemAtual) {
              this.wmsOsItensSepData = [itemAtual]
            }

            if (this.wmsOsItensData.length === 0) {
              this.efetivarSepPend()
            }

            console.log('limpando wmsOsItemData')
            this.wmsOsItemData = {}
            this.$refs.produto.value = null
            this.$refs.qtdlida.value = null

            console.log('retornando foco')
            this.$refs.produto.focus()
            console.log('===========================')
          }
        } else {
          console.log('vai')
          console.log(this.wmsOsItemData)
          this.updatingListas = true
          this.wmsOsItemData['idwmsos'] = this.idData
          api.post(`${getBaseUrl()}api/wmsositconfseptransp`, {
            'movItemSepData': this.wmsOsItemData,
            'autoImpressao': this.autoImpressao
          }).then((res) => {
            console.log('then axios separar2_2')
            console.log(res.data)
            this.wmsOsItensSepData = res.data[0]
            this.wmsOsData = res.data[1]
            this.wmsOsItensData = this.filtrarDisponiveis(res.data[2])
            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }
            if (this.wmsOsItensSepData.length > 0) {
              this.wmsOsItensSepData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }
            this.wmsOsVolumesData = res.data[3]
            if (this.wmsOsItensData.length === 0) {
              console.log('finalizar_auto')
              this.wmsOsData.status = 'SE'
              this.confirmarFinalizar()
            } else {
              console.log('produto focus')
              setTimeout(() => {
                this.$refs.produto.focus()
              }, 500);
            }
          }).then(() => {
            this.updatingListas = false
            this.wmsOsItemData.qtd = 0
            this.wmsOsItemData.qtdlida = 0
            this.wmsOsItemData.produto = ''
          })
        }
      }
    },

    /*
    * Por hora será utilizado para os clientes até desenvolvimento de disparo de dados para o back-end para cada bip
    */
    informouQtdLida2() {
      console.log('=============== informouQtdLida2 ===============')
      //console.log(`qtdlida: ${this.wmsOsItemData.qtdlida}`)
      //console.log(`qtddisp: ${this.wmsOsItemData.qtddisp}`)
      //console.log(`wmsOsItemData: ${JSON.stringify(this.wmsOsItemData)}`)


      let passaSaldo = false
      let qtdLidaAtual = 0

      //!this.wmsOsItemData.qtddisp || this.wmsOsItemData.qtdlida > this.wmsOsItemData.qtddisp
      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        // acumular lista para separar muitos
        console.log('acumular lista para separar muitos')

        let quantDisponivel = false

        for(const prod of this.wmsOsItensData) {
          if (prod.id === this.wmsOsItemData.iditem) {
            //console.log(`prod atual para baixa: ${JSON.stringify(prod)}`);

            if (!this.wmsOsItemData.lote && (prod.deflote && !prod.lote)) {
              this.opcoesLotes()
              return;
            }

            this.showModalLote = false

            qtdLidaAtual = this.roundToDecimal(parseFloat(this.wmsOsItemData.qtdlida), 4);
            //console.log(`baixa qtdLidaAtual: ${qtdLidaAtual}`);

            if (prod.composicao) {
              if (prod.qtddisp >= 0) {
                //console.log('baixa de produto composição...');

                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
                //console.log(`qtddisp remaining: ${prod.qtddisp}`);

                // Validando se terminou de conferir o item atual
                if (prod.qtddisp < 0) {
                  prod.qtddisp = 0;
                  quantDisponivel = false;
                }
              }
            } else {
              //console.log('baixa de produto comum...');

              if (prod.qtddisp >= qtdLidaAtual) {
                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
              }
            }

            if (prod.qtddisp === 0) {
              this.wmsOsItensData.splice(this.wmsOsItensData.indexOf(prod), 1);
              this.totalItens--
            }
            break;
          }
        }


        if (quantDisponivel === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Quantidade do produto indisponível para separação",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          this.finalizarParcialBtn = true

          if (this.wmsOsItemData.lote) {
            //console.log("LOTE INFORMADO")

            const lote = this.wmsOsItemData.lote;
            //console.log(`informouQtdLida2 lote: ${lote}`)

            const endwms = this.wmsOsItemData.endwms
            //console.log(`informouQtdLida2 endwms: ${endwms}`)

            let existeProdPend = false;
            let existeProd = false;

            /* verificando se lote já existe em wmsOsItensSepPendData */
            this.wmsOsItensSepPendData.forEach((prod) => {
              //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProdPend = true;
                //console.log('atualizando dados do item na lista wmsOsItensSepPendData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  //console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  //console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* verificando se lote já existe em in wmsOsItensSepData */
            this.wmsOsItensSepData.forEach((prod) => {
              //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProd = true;
                //console.log('atualizando dados do item na lista wmsOsItensSepData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  //console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  //console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* Criando novos itens nas coleções */
            if (!existeProdPend) {
              console.log('criando novo item na lista wmsOsItensSepPendData')

              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              console.log('criando novo item na lista wmsOsItensSepData')

              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }
            console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
            console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)

          } else {
            console.log("LOTE NÃO INFORMADO")

            let existeProdPend = false;
            let existeProd = false;

            this.wmsOsItensSepPendData.forEach((prod) => {
              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProdPend = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });


            this.wmsOsItensSepData.forEach((prod) => {
              if (prod.iditem === this.wmsOsItemData.iditem) {
                existeProd = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /*Criando novos itens nas coleções */
            if (!existeProdPend) {
              console.log('criando novo wmsOsItensSepPendData')

              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              console.log('criando novo wmsOsItensSepData')

              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }
            //console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
            //console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)
          }

          //ordenando em desc e destacando o item atual para o topo
          const idItemAtual = this.wmsOsItemData.iditem

          const itemAtual = this.wmsOsItensSepData.find(item =>
              item.iditem === idItemAtual
          );
          const outrosItens = this.wmsOsItensSepData.filter(item =>
              !(item.iditem === idItemAtual)
          );

          if (outrosItens && outrosItens.length > 0) {
            outrosItens.sort((a, b) => b.iditem - a.iditem);

            this.wmsOsItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
          } else if (itemAtual) {
            this.wmsOsItensSepData = [itemAtual]
          }

          if (this.totalItens === 0) { //this.wmsOsItensData.length
            this.finalizadorConferencia()
            // this.imprimirPdf()
          }

          console.log('limpando wmsOsItemData')
          this.wmsOsItemData = {}
          this.$refs.produto.value = null
          this.$refs.qtdlida.value = null

          console.log('retornando foco')
          this.$refs.produto.focus()
          console.log('===========================')
        }
      }
    },

    roundToDecimal(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round(num * factor) / factor;
    },

    filtrarDisponiveis(arrayEntr) {
      //this.wmsOsItensData = res.data[6]
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        if (value.qtddisp > 0) {
          /*
          * Verificando se existe composição novamente
          */
          if(value.composicao) {
            this.flagConferenciaCompos = true
          }

          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsossaida`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))
        this.updating = false
        this.updatingListas = false

        this.flagFinalizado = res.data[14]
        if(this.flagFinalizado){
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Ordem finalizada!",
            text: "Fluxo de etiqueta e saldo realizado!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.carregarDados()
          })
          return
        }

        if('success' in res.data && res.data.success !== true) {
          console.log('itens não foram completamente validados!')
          this.remetCnpj = res.data.remetcnpj
          if(res.data.erroTipo === 'saldo'){
            console.log('reserva de saldos pendentes')

            Swal.fire({
              position: "center",
              icon: "info",
              title: res.data.message ?? "Erro com saldo/separação de itens!",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            }).then(() => {
              this.dtListErrorsProdutos = res.data.itensSemSaldo
              this.showModalErrosProdutos = true
            })
          } else if(res.data.erroTipo === 'reserva') {
            console.log('reserva de saldos pendentes')

            this.showModalAssociaLotes = true
            this.dtListAssociaLote = res.data.defLotes
          } else if (res.data.erroTipo === 'empresa') {
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              text: res.data.dadosEmpresa,
              showConfirmButton: true,
            }).then(() => {
              this.$router.push('/wmsossaida/list')
            })
          }

          return
        }

        this.wmsOsData = res.data[0]

        this.wmsOsListData = res.data[4]
        this.wmsOsVolumesData = res.data[1]

        let pesoVols = 0;
        this.wmsOsVolumesData.forEach((value) => {
          pesoVols += value.peso
        });
        this.somaQtdVolumes = this.wmsOsVolumesData.length
        this.somaPesoVolumes = pesoVols

        // this.transpData = res.data[2]
        this.clienteData = res.data[3]
        this.movData = res.data[5]

        //console.log(`->carregarDados wmsOsItensData: ${JSON.stringify(res.data[6])}`)
        this.wmsOsItensData = this.filtrarDisponiveis(res.data[6])
        
        this.wmsOsItensData.forEach((item) => {
          if(!item.desconsidsaldo){
            this.totalItens++
          }
        })


        this.itenswmsos = res.data[6]
        this.wmsOsItensSepData = res.data[7]
        //console.log(`itens separados: ${JSON.stringify(res.data[7])}`)


        this.tipoConferencia = this.flagProdutoSaldoWmsos ? 'M' : 'A'

        //Validando dados dadempresa
        if(!res.data[8]){
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Inconsistência nos dados da Empresa emissora do Wmsos",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }

        this.empresaData = res.data[8]
        //console.log(`empresaData: ${JSON.stringify(this.empresaData)}`)
        // console.log(`empresaData.wmsosauto: ${this.empresaData.wmsosauto}`)

        this.tipoConferencia = this.empresaData.wmsosauto ?? 'A'
        this.mudarConferencia = this.empresaData.wmsconf ? this.empresaData.wmsconf : 'P'

        // REGRA DESATIVADA POIS NÃO ATENDE A ORDEM ORIGINADA DE ORÇAMENTO (ROGERIO)
        /*this.wmsOsDuplicadaData = res.data[9]
        if (this.wmsOsDuplicadaData && this.wmsOsDuplicadaData.id) {
          console.log('desativando funções...')
          this.desativaFuncoes = true

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de serviço em duplicidade, excluir esta ou a id: " + this.wmsOsDuplicadaData.id + " antes de continuar.",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }*/


        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        this.optionsCaixas = res.data[9]
        //console.log("OPTIONS CAIXA" , res.data[9])

        this.dadosConferentes.ultimoConferente = res.data[10]
        this.dadosConferentes.criadorConferente = res.data[11]
        this.dadosConferentes.conferenteModel = res.data[12]

        if (res.data[13]) {
          this.flagParametroPdf = true
          console.log('parametro pdf ativo')
        }

        this.idData = this.wmsOsData.id
        this.title = `Editar OS de Saída (${this.wmsOsData.id}) ${this.clienteData != null ? this.clienteData.cidade + '/' + this.clienteData.estado : ''}`
        this.updating = false
      }).then(() => {
        setTimeout(() => {
          this.$refs.produto.focus()
        }, 500)
      })
    },

    confirmarVolume() {
      console.log('confirmarVolume')
      if (this.wmsOsVolumeData.qtd > 0) {
        this.loadingWmsVolume = true
        //console.log('volumeData: ', this.wmsOsVolumeData)

        const caixaSelecionada = this.optionsCaixas.find(caixa => caixa.id === this.wmsOsVolumeData.caixa);

        const dataToSend = {
          'idwmsos': this.idData,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
          'caixa': this.wmsOsVolumeData.caixa,
          'descricao': caixaSelecionada ? caixaSelecionada.descricao : 'N/A',
          'cubagem': caixaSelecionada ? caixaSelecionada.cubagem : 0
        };

        api.post(`${getBaseUrl()}api/wmsosconfvol`, dataToSend)
            .then((res) => {
              console.log('then axios conf_vol')
              console.log(res.data)

              if(res.data.error){
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.error,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.loadingWmsVolume = false
                  return
                })
              }

              const volumesRetornados = res.data[0];
              const volumesComInfoCaixa = volumesRetornados.map(volume => {
                const caixaInfo = this.optionsCaixas.find(caixa => caixa.id === volume.caixa_id);
                return {
                  ...volume,
                  descricao: caixaInfo ? caixaInfo.descricao : 'N/A',
                  cubagem: caixaInfo ? caixaInfo.cubagem : 0
                };
              });

              this.wmsOsVolumesData = volumesComInfoCaixa;

              let totalVols = 0
              let pesoVols = 0
              this.wmsOsVolumesData.forEach((value) => {
                totalVols += value.qtd
                pesoVols += value.peso
              });
              this.somaQtdVolumes = totalVols
              this.somaPesoVolumes = pesoVols
              this.loadingWmsVolume = false
              this.wmsOsVolumeData = {}
              this.$refs.caixapadrao.focus()
            })
            .catch(error => {
              console.error("Erro ao confirmar volume: ", error);
              this.loadingWmsVolume = false;
            });
      }
    },


    nomeStatusWms(stsIn) {
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 4 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    imprimirPdf() {
      console.log('imprimirPdf');

      api.post(`${getBaseUrl()}api/wmsossaidarelatorio`, {
        'iddata': this.idData
      }, {
        responseType: 'arraybuffer'
      })
        .then((res) => {

          const contentType = res.headers['content-type'];

          if (contentType && contentType.includes('application/pdf')) {

            const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', `itenssepardos${String(this.idData)}.pdf`);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);

          } else if (contentType && contentType.includes('application/json')) {

            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(res.data);
            const jsonResponse = JSON.parse(text);

            console.error('Erro ao gerar PDF:', jsonResponse.message);

          } else {
            console.error('Erro desconhecido: tipo de resposta inesperado.');
          }
        })
        .catch(error => {
          console.error('Erro na requisição:', error);
        });
    }
  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="wmsOsData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>



    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="col-lg-12" v-if="!updating">
      <div class="card">

          <div class="card-body">
            <div class="d-flex align-items-start">

              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <h5>{{ wmsOsData !== null ? formatInteger(wmsOsData.qtddisp) : 0 }} pendente(s)</h5>
                  <p class="mb-1">{{ wmsOsData !== null ? formatInteger(wmsOsData.qtdlida) : 0 }} conferido(s) com sucesso
                  </p>

                  <p class="mb-1" v-if="wmsOsData && wmsOsData.dtconcl">
                    Usuário <strong>{{ wmsOsData !== null ? wmsOsData.updated_by : '' }}</strong>
                    <span> Conclusão: <strong> {{  formatDateTime(wmsOsData.dtconcl) }} </strong> </span>
                  </p>

                  <p class="mb-1">
                    <strong>Origem:</strong>
                    {{ wmsOsData.origem == 'orcamento' ? 'Orçamento' : wmsOsData.origem == 'nota' ? 'Mov' : wmsOsData.origem }}
                      - <strong>Id:</strong> <a href="javascript: void(0);" @click="redirecionaOrigem">{{ wmsOsData.origem_id }}</a>
                  </p>

                  <p class="mb-1">
                    <strong>Criado por:</strong> {{ dadosConferentes.criadorConferente }} ({{`${formatDateTime(wmsOsData.created_at)}`}})
                  </p>

                  <p class="mb-1">
                    <strong>Último conferente:</strong> {{ dadosConferentes.ultimoConferente ?? dadosConferentes.conferenteModel }} ({{`${formatDateTime(wmsOsData.updated_at)}`}})
                  </p>
                </div>
              </div>

              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>




              <PageActionBar
                :primary-actions="[
                  {
                    label: 'Salvar (alt + A)',
                    icon: 'bx bx-check',
                    variant: 'outline-primary',
                    onClick: efetivarSepPend2,
                    visible: wmsOsItensSepPendData.length > 0
                  },
                  {
                    label: 'PDF separação',
                    icon: 'bx bx-printer',
                    variant: 'outline-warning',
                    onClick: imprimirPdf,
                    visible: flagParametroPdf && (wmsOsData.status == 'SE' || wmsOsItensSepData.length > 0)
                  }
                ]"
                :secondary-actions="[
                  {
                    label: `Romaneio: ${wmsOsData.wmsroma_id}`,
                    variant: 'outline-primary',
                    onClick: associarRomaneio,
                    disabled: wmsOsData.status !== 'AB'
                  },
                  {
                    label: 'Etiquetas Mini Danfe (alt + F)',
                    icon: 'bx bx-printer',
                    variant: 'outline-primary',
                    onClick: imprimirEtiquetasZpl,
                    disabled: !wmsOsVolumesData || wmsOsVolumesData.length === 0
                  },
                  {
                    label: 'Volumes (alt + V)',
                    icon: 'bx bx-box',
                    variant: 'outline-primary',
                    onClick: () => showModalVolume = true
                  },
                  {
                    label: 'Reiniciar (alt + R)',
                    icon: 'bx bx-sync',
                    variant: 'outline-warning',
                    onClick: reiniciar,
                    visible: wmsOsData.status === 'AB',
                    disabled: wmsOsItensData.length === 0
                  },
                  {
                    label: 'Conferir Todos',
                    icon: 'bx bx-sync',
                    variant: 'outline-success',
                    onClick: separarTodos,
                    visible: (wmsOsData.status === 'ES' || wmsOsData.status === 'AB') && !flagProdutoSaldoWmsos,
                    disabled: selectedFinalizado
                  },
                  {
                    label: 'Finalizar OS Parcialmente',
                    icon: 'bx bx-sync',
                    variant: 'outline-info',
                    onClick: finalizarParcial,
                    visible: wmsOsData.status === 'ES' || (wmsOsData.status === 'AB' && finalizarParcialBtn),
                    disabled: selectedFinalizado
                  },
                  {
                    label: 'Excluir',
                    icon: 'mdi mdi-trash-can',
                    variant: 'outline-danger',
                    onClick: excluir,
                    visible: wmsOsData.status === 'ES' || wmsOsData.status === 'AB' || wmsOsData.status === 'EL'
                  }
                ]"
              />

            </div>
          </div>


      </div>
    </div>





    <div class="row" v-if="!updating">




      <!--<div class="col-xl-2" v-if="tamanhoTela > 500">
        <div class="card">
          <div class="card-body">

            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                  <tr>
                    <th class="text-start">Ped.</th>
                    <th class="text-start">Status</th>

                  </tr>
                </thead>
                <tbody>

                  <tr v-for="data in wmsOsListData" :key="data.id">
                    <td class="text-start">
                      <a href="javascript: void(0);" class="text-body fw-bold  text-wrap"
                        @click="abrirOutraOS(data.id)">
                        <h5 class="text-muted mb-0">{{ data.codigo }} </h5>
                        {{ data.id }}
                      </a>
                    </td>
                    <td class="text-start">
                      <span class="badge badge-pill badge-soft-success font-size-11"
                        :class="data.stswms === 'SE' ? 'badge-soft-success' : 'badge-soft-danger'">
                        {{ nomeStatusWms(data.stsep) }}
                      </span>
                      <p>
                        {{ formatInteger(data.qtdlida) }}
                        de
                        {{ formatInteger(data.qtd) }}
                      </p>

                      <p v-if="data.stsocor === 'A'">
                        <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-danger">
                          Ocorrência
                        </span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>-->

      <div class="col-12 col-xl-8">
        <b-card-text>
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <form class="needs-validation">
                <div class="row">
                  <div class="col-sm-6" v-if="wmsOsData.origem == 'mov'">
                    <div class="mb-3">
                      <label for="chave">Chave</label>
                      <input id="chave" v-model="movData.chave" type="text" class="form-control" placeholder="Chave" ref="chave"
                        :disabled="computedDisabledChave" :class="{ 'is-invalid': submitted && !movData.chave }" @keydown.enter="carregaWmsOs" />
                      <div v-if="submitted && !movData.chave" class="invalid-feedback">
                        <span>Campo nome obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>


                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="cliente">Cliente</label>
                      <input id="cliente" v-model="clienteData.nome" type="text" :disabled="true" class="form-control"
                        placeholder="Cliente" />
                    </div>
                  </div>


                  <div class="col-sm-2" v-if="wmsOsData.origem == 'orcamento'">
                    <div class="mb-3">
                      <label for="numnf">Orçamento</label>
                      <input id="numnf" v-model="wmsOsData.origem_id" type="text" :disabled="true" class="form-control"
                        placeholder="Nota F." />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="wmsOsData.origem == 'mov'">
                    <div class="mb-3">
                      <label for="numnf">Nota Fiscal</label>
                      <input id="numnf" v-model="movData.codigo" type="text" :disabled="true" class="form-control"
                             placeholder="Nota F." />
                    </div>
                  </div>


                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label for="produto">Código do Item</label>
                      <!--Regra de disable retirada(Pablo)-->
                      <!--:disabled="this.updatingListas || wmsOsData.status !== 'EL'"-->
                      <input id="produto" v-model="wmsOsItemData.produto" type="text" ref="produto" class="form-control"
                        placeholder="Produto (alt + S)" @keypress.enter="informouProduto"
                        :class="{ 'is-invalid': submitted && !wmsOsItemData.produto }" />
                      <div v-if="submitted && !wmsOsItemData.produto" class="invalid-feedback">
                        <span>Campo nome obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label for="qtd">Quantidade de Itens</label>
                      <input id="qtd" v-model="wmsOsItemData.qtd" type="number" :disabled="true" class="form-control"
                        placeholder="Quantidade de Itens" />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label for="qtdlida">Quantidade a ser lida</label>
                      <input id="qtdlida" ref="qtdlida" v-model="wmsOsItemData.qtdlida" type="number"
                        class="form-control" :disabled="tipoConferencia === 'A'" @keypress.enter="informouQtdLida2"
                        placeholder="Quantidade a ser lida" />
                    </div>
                  </div>

                  <!--                  <div class="col-sm-3">-->
                  <!--                    <div class="mb-3 align-items-end align-content-end float-end">-->
                  <!--                      <h5 class="font-size-14">1 Volume</h5>-->
                  <!--                      <b-form-checkbox-->
                  <!--                          switch size="lg"-->
                  <!--                          value="A"-->
                  <!--                          unchecked-value="I"-->
                  <!--                          v-model="tipoVolume">-->
                  <!--                        {{ tipoVolume === 'A' ? 'Sim' : 'Não' }}-->
                  <!--                      </b-form-checkbox>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <div class="col-sm-6">
                    <div class="mb-3 align-items-end align-content-end float-end" v-if="flagAvulso">
                      <h5 class="font-size-14">Auto-impressão</h5>
                      <b-form-checkbox switch size="lg" v-model="autoImpressao" @click="changeAutoImpressao">
                        {{ autoImpressao === true ? 'On' : 'Off' }}
                      </b-form-checkbox>
                    </div>

                    <div v-if="this.mudarConferencia === 'P'" class="mb-3 align-items-end align-content-end float-end">
                      <h5 class="font-size-14">Conferência</h5>
                      <b-form-checkbox switch size="lg" value="A" unchecked-value="I" v-model="tipoConferencia">
                        {{ tipoConferencia === 'A' ? 'Auto' : 'Manual' }}
                      </b-form-checkbox>
                    </div>
                  </div>

                  <div class="row"></div>
                </div>

              </form>


              <Loader v-if="updatingListas" style="min-height: 200px;">
              </Loader>
              <div class="row mt-5 mb-2" v-if="!updatingListas">
                <h4 class="card-title">Itens do pedido para separação ({{ wmsOsItensData !== null ?
                  wmsOsItensData.length : 0 }}) - Status:  <span class="badge badge-pill badge-soft-info font-size-16">{{ nomeStatus(wmsOsData.status) }}</span></h4>
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th>Produto</th>
                        <th>Descrição</th>
                        <th class="text-end">Localização</th>
                        <th class="text-end">Lote</th>
                        <th class="text-end">Lidos</th>
                        <th class="text-end">Total</th>
                        <th>UND</th>
                        <th class="text-end">Estoque</th>
                        <th class="text-start" v-if="flagConferenciaCompos">Composição de Produto</th>
                        <th class="text-end" v-if="flagConferenciaCompos">Valor</th>
                        <th class="text-end" v-if="flagConferenciaCompos">Fator</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in wmsOsItensData" :key="index">
                        <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                          @click="clicouProduto(data.produto, data.id, data.produto_id, data.composicao?.qtd ?? null, data.composicao?.fator ?? null, data.lote, data.endwms)">
                          <td>
                            <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img"
                              class="avatar-md" />

                            <div class="mb-3" v-else>
                              <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                            </div>

                            <h6 class="text-muted mb-0">Sku: {{ data.codigo }} </h6>
                            <!--                          <p></p>-->
                            <h4 class="text-muted mb-0">{{ data.produto }} </h4>
                          </td>
                        </a>


                        <td :class="{'item-blocked': data.desconsidsaldo}">
                          <h5 class="font-size-14 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                              @click="editarProduto(data.id)">
                              {{ data.descprod }}
                            </a>
                          </h5>
                        </td>

                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ data.endwms ?? '-'}}</td>
                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ data.lote ?? '-' }}</td>
                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ formatDecimal(data.qtdlida) }}</td>
                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ formatDecimal(data.qtd) }}</td>
                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ data.und !== null ? data.und : '-'}}</td>
                        <td class="text-end" :class="{'item-blocked': data.desconsidsaldo}">{{ '-' }}</td>

                        <td class="text-end" v-if="flagConferenciaCompos" :class="{'item-blocked': data.desconsidsaldo}">
                          {{ data.composicao &&  data.composicao?.prodcomp_id ? data.composicao?.prodcomp_id : '-' }}
                        </td>
                        <td class="text-end" v-if="flagConferenciaCompos" :class="{'item-blocked': data.desconsidsaldo}">
                          {{ data.composicao &&  data.composicao.qtd ? formatDecimal(data.composicao?.qtd) : '-' }}
                        </td>
                        <td class="text-end" v-if="flagConferenciaCompos" :class="{'item-blocked': data.desconsidsaldo}">
                          {{
                            data.composicao && data.composicao?.fator
                                ? (data.composicao?.fator === '/' ? 'Divisão' : 'Multiplicação')
                                : '-'
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-card-text>
      </div>


      <div class="col-12 col-xl-4">

        <b-card-text>
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <div class="row mb-2">

                <Loader v-if="updatingListas" style="min-height: 200px;">
                </Loader>

                <h4 class="card-title">Produtos lidos ({{ wmsOsItensSepData !== null ? wmsOsItensSepData.length : 0 }})
                </h4>

                <div class="table-responsive" v-if="!updatingListas">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th>Produto</th>
                        <th>Descrição</th>
                        <th>Lote</th>
                        <th class="text-success">Conferidos</th>
                        <th class="text-danger">Pendentes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data) in wmsOsItensSepData" :key="`${data.iditem}-${data.lote}`">
                        <td>
                          <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img"
                            class="avatar-md" />

                          <div class="mb-3" v-else>
                            <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                          </div>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                              @click="editarProduto(data.id)">
                              {{ data.descprod }}
                            </a>
                          </h5>

                          <h6 class="text-muted mb-0">Sku: {{ data.codigo }} </h6>
                          <h6 class="text-black-50 mb-0">{{ data.produto }} </h6>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate text-start">
                            {{ data.lote ?? "-" }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate text-start">
                            {{ formatDecimal(data.qtd) }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate text-start">
                            {{ wmsOsData.status === 'AB' ? formatDecimal(data.qtdtotal) : 0 }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-card-text>
      </div>
    </div>


    <b-modal size="lg" @shown="$refs.caixapadrao.focus()" @hidden="onModalClosed" title="Identificar Volume(s)" v-model="showModalVolume" centered
      hide-footer>

      <div class="row">

        <div class="col-md-4">
          <div class="mb-3">
            <label for="caixapadrao">Caixa Padrão</label>
            <select
                id="caixapadrao"
                ref="caixapadrao"
                class="form-select"
                v-model="wmsOsVolumeData.caixa"
                @change="escolheuCaixa"
            >
              <option disabled value="">Selecione uma caixa</option>
              <option
                  v-for="caixa in optionsCaixas"
                  :key="caixa.id"
                  :value="caixa.id"
              >
                {{ caixa.descricao }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="quantidade">Quantidade</label>
            <input id="qtdvolume" ref="qtdvolume" v-model="wmsOsVolumeData.qtd" type="number" style="padding: 9.4px 10px"
              class="form-control text-end" @keypress.enter="informouQtdVolume" placeholder="Enter para confirmar..." />
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="pesovolume">Peso</label>
            <input id="pesovolume" ref="pesovolume" v-model="wmsOsVolumeData.peso" type="text" style="padding: 9.4px 10px"
              class="form-control text-end" @keypress.enter="informouPeso" placeholder="Enter para confirmar..." />
          </div>
        </div>
        <div class="col-4 ms-auto text-end">
          <b-button type="submit" variant="warning"
                    :disabled="!this.wmsOsVolumeData.caixa || !this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0"
                    @click="confirmarVolume">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Enter Novo Volume
          </b-button>
        </div>
      </div>


      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col" class="">ID</th>
            <th scope="col" class="">Etiqueta</th>
            <th scope="col" class="">Descricao</th>
            <th scope="col" class="">Cubagem</th>
            <th scope="col" class="text-end">Peso</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="data in wmsOsVolumesData" :key="data.id">
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.id }}
                  </h5>
                </div>
              </td>
              <td class="text-info">
                <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)">
                  <i class="mdi mdi-printer"></i>
                  {{ data.etiqueta }}
                </a>
              </td>
              <td>{{ data.descricao }}</td>
              <td>{{ formatDecimal(data.cubagem) }}</td>
              <td class="text-end">{{ formatDecimal(data.peso) }}</td>
            </tr>
          </tbody>
        </table>
      </div>


      <div>
        <label><strong>Total Qtd.:</strong> <span>{{ formatDecimal(somaQtdVolumes) }}</span></label>
        <label class="ms-4"><strong>Total Peso:</strong> <span>{{ formatDecimal(somaPesoVolumes) }}</span></label>
      </div>


      <div class="text-end mt-5">
        <b-button type="submit" variant="outline-danger" v-if="wmsOsVolumesData.length > 0"
          @click="excluirEtiquetas">
          <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
          Excluir Etiquetas
        </b-button>

        <b-button v-if="wmsOsVolumesData?.length > 0" type="submit" variant="success" class="ms-2"
          @click="showModalVolume = false">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar Volumes
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Associar a Romaneio" v-model="showAssocRoma" centered hide-footer>
      <div class="col-md-12">
        <!--        <div class="mb-3">-->
        <!--          <label for="wmsroma_id">Favor informar ID Romaneio</label>-->
        <!--          <input-->
        <!--              id="Id wmsroma_id"-->
        <!--              v-model="idRomaneioAssoc"-->
        <!--              type="number"-->
        <!--              class="form-control"-->
        <!--              placeholder="ID Romaneio"/>-->
        <!--        </div>-->

        <div class="mb-3">
          <span>Selecionar Romaneio</span>

          <multiselect id="inputRomaneio" @search-change="pesqRomaneio" v-model="wmsOsData.wmsroma_id"
            placeholder="Pesquisar romaneio" :options="dtListPesqRoma" :searchable="true" label="nome" track-by="nome"
            value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button :disabled="wmsOsData.wmsroma_id === 0" type="submit" variant="success" class="ms-1"
            @click="confirmarAssocRoma()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal
        v-model="showModalErrosProdutos"
        id="showModalErrosProdutos"
        size="xl"
        title="Validação de saldo de produtos"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Origem</th>
                    <th>Nota|Pedido</th>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Lote</th>
                    <th>Qtd. Disponível</th>
                    <th>Qtd. Necessária</th>
                    <!--<th>Obs</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrorsProdutos" :key="data.id">
                    <td class="text-start">{{data.origem}}</td>
                    <td class="text-start">{{data.codigo}}</td>
                    <td class="text-start">{{data.produto_desc}}</td>
                    <td class="text-start">{{data.produto_cod}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-start">{{data.lote ?? "-"}}</td>
                    <td class="text-center">{{formatDecimal(data.qtddisp)}}</td>
                    <td class="text-center">{{formatDecimal(data.qtdnecessaria)}}</td>
                    <!--<td class="text-start">{{data.message ?? "-"}}</td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div>
            <h6 class="text-danger text-end">Deseja gerar um ajuste de entrada?</h6>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalErrosProdutos = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="criaMovAjtFromWms"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalAssociaLotes"
        id="showModalAssociaLotes"
        size="xl"
        title="Associação de lotes"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Qtd.</th>
                    <th>Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListAssociaLote" :key="data.id">
                    <td class="text-start">{{data.descprod}}</td>
                    <td class="text-start">{{data.produto}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-center">{{formatDecimal(data.qtd)}}</td>
                    <td class="text-center" style="width: 200px">
                      <multiselect
                          id="lotes"
                          v-model="data.lote"
                          :options="data.optionsLotes"
                          placeholder="Selecionar lotes"
                          label="cod"
                          track-by="cod"
                          value-prop="cod"
                      >
                        <template #option="slotProps">
                          <div class="row">
                            <div class="mt-2 font-size-16">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                              <span class="ms-2">
                                {{ `(Qtd: ${slotProps.option.saldo})` }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="updatingReserva">
            <h3 class="text-info text-center">Aguarde um momento, estamos reservando os saldos dos produtos...</h3>
          </div>

          <div class="row" v-if="updatingReserva">
            <div class="col-12 text-center">
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
            </div>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAssociaLotes = false" :disabled="updatingReserva">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="gerarReservaSaldos"
                :disabled="updatingReserva"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalMsgUpdating"
        id="showModalMsgUpdating"
        size="lg"
        hide-footer
    >
      <div>
        <h3 class="text-info text-center">Aguarde um momento, estamos processando os dados...</h3>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>
    </b-modal>

    <b-modal title="Confer. Lote" v-model="showModalLote" centered hide-footer>
      <div class="col-md-12">

        <div class="col-6">
          <div class="mb-3">
            <label for="lote">Lotes</label>
            <select
                id="lotes"
                ref="selectLotes"
                class="form-select form-select-sm"
                style="padding: 5px 10px"
                v-model="wmsOsItemData.lote"
                @change="selecionouLote"
            >
              <option disabled :value="null">Selecione uma Lote</option>
              <option v-for="lotes in dtListLotes"
                      :key="lotes.lote"
                      :value="lotes.lote"
              >
                {{ lotes.lote }}
              </option>
            </select>
          </div>
        </div>

        <div class="row justify-content-around mt-5">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showModalLote = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="selecionouLote()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>

    </b-modal>

  </Layout>
</template>

<style scoped>
  .item-blocked{
    background-color: #c6c6c6;
  }
</style>